var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TinyMCE from 'components/shared/TinyMCE/component';
import { adminUpdateTemplateAction } from '../../../../../../redux/actions/admin/admin.template.actions';
export default function TemplateGeneral() {
    var _a, _b, _c, _d, _e, _f;
    var dispatch = useDispatch();
    var template = useSelector(function (state) { return state.admin.singleTemplate; });
    var transactionSettings = template.transactionSettings, taskSettings = template.taskSettings;
    var _g = useState(template.description), editorText = _g[0], setEditorText = _g[1];
    var _h = useState({
        playerToPlayer: transactionSettings === null || transactionSettings === void 0 ? void 0 : transactionSettings.playerToPlayer,
        playerToCompany: transactionSettings === null || transactionSettings === void 0 ? void 0 : transactionSettings.playerToCompany,
        companyToPlayer: transactionSettings === null || transactionSettings === void 0 ? void 0 : transactionSettings.companyToPlayer,
        companyToCompany: transactionSettings === null || transactionSettings === void 0 ? void 0 : transactionSettings.companyToCompany,
        playerTasks: taskSettings === null || taskSettings === void 0 ? void 0 : taskSettings.playerCards,
        companyTasks: taskSettings === null || taskSettings === void 0 ? void 0 : taskSettings.companyCards
    }), formCheckboxValues = _h[0], setFormCheckboxValues = _h[1];
    function onCheckboxClick(property) {
        setFormCheckboxValues(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[property] = !prev[property], _a)));
        });
    }
    function onFormSubmit(e) {
        e.preventDefault();
        var target = e.target;
        dispatch(adminUpdateTemplateAction(template._id, {
            name: target.name.value,
            description: editorText,
            transactionSettings: {
                playerToPlayer: formCheckboxValues.playerToPlayer,
                playerToCompany: formCheckboxValues.playerToCompany,
                companyToPlayer: formCheckboxValues.companyToPlayer,
                companyToCompany: formCheckboxValues.companyToCompany
            },
            taskSettings: {
                playerCards: formCheckboxValues.playerTasks,
                companyCards: formCheckboxValues.companyTasks,
                unusedTicketsCount: {
                    game: {
                        player: Number(target.player_tasks_max.value),
                        company: Number(target.company_tasks_max.value)
                    }
                }
            }
        }));
    }
    var checkboxFields = [
        { key: 'playerToPlayer', label: 'Allow Player to Player transactions' },
        { key: 'playerToCompany', label: 'Allow Player to Company transactions' },
        { key: 'companyToPlayer', label: 'Allow Company to Player transactions' },
        { key: 'companyToCompany', label: 'Allow Company to Company transactions' },
        { key: 'playerTasks', label: 'Allow player tasks' },
        { key: 'companyTasks', label: 'Allow company tasks' }
    ];
    return (React.createElement("form", { onSubmit: onFormSubmit, className: "text-align-left admin-form" },
        React.createElement("div", { className: "mar-top-5 admin-form__area" },
            React.createElement("span", null, "Template name:"),
            React.createElement("input", { type: "text", name: "name", defaultValue: template.name })),
        React.createElement("div", { className: "mar-top-5 admin-form__area" },
            React.createElement("span", null, "Template description:"),
            React.createElement(TinyMCE, { value: editorText || null, onChange: function (value) { return setEditorText(value); } })),
        React.createElement("div", { className: "mar-top-5 admin-form__area" },
            React.createElement("span", null, "Max player tasks in progress:"),
            React.createElement("input", { type: "number", name: "player_tasks_max", defaultValue: ((_c = (_b = (_a = template === null || template === void 0 ? void 0 : template.taskSettings) === null || _a === void 0 ? void 0 : _a.unusedTicketsCount) === null || _b === void 0 ? void 0 : _b.game) === null || _c === void 0 ? void 0 : _c.player) || 10 })),
        React.createElement("div", { className: "mar-top-5 admin-form__area" },
            React.createElement("span", null, "Max company tasks in progress:"),
            React.createElement("input", { type: "number", name: "company_tasks_max", defaultValue: ((_f = (_e = (_d = template === null || template === void 0 ? void 0 : template.taskSettings) === null || _d === void 0 ? void 0 : _d.unusedTicketsCount) === null || _e === void 0 ? void 0 : _e.game) === null || _f === void 0 ? void 0 : _f.company) || 10 })),
        checkboxFields.map(function (_a) {
            var key = _a.key, label = _a.label;
            return (React.createElement("div", { key: key, className: "mar-top-5 admin-form__area" },
                React.createElement("label", null,
                    React.createElement("input", { type: "checkbox", defaultChecked: formCheckboxValues[key], onChange: function () { return onCheckboxClick(key); } }),
                    React.createElement("span", null, label))));
        }),
        React.createElement("button", { className: "main-button", type: "submit" }, "Kinnita")));
}
